import { Inject, Injectable } from '@angular/core';
import { State, StateContext, Action, Selector } from '@ngxs/store';
import { FeatureApi, FeatureDTO } from '@lkp/parking-sdk';
import { FEATURE_API } from '../../providers/api.module';
import * as Actions from './feature.action';
import { tap } from 'rxjs';

export interface FeaturesStateModel {
  features: FeatureDTO[];
}

@State<FeaturesStateModel>({
  name: 'features',
  defaults: {
    features: [],
  },
})
@Injectable()
export class FeaturesState {
  constructor(@Inject(FEATURE_API) readonly featureApi: FeatureApi) {}

  @Selector()
  static features(state: FeaturesStateModel) {
    return state.features;
  }

  @Action(Actions.GetFeatures)
  getFeatures(context: StateContext<FeaturesStateModel>) {
    // Wait for David to add enpoint that fetches all features. This only gets the main features. See also findFeatures endpoint.
    return this.featureApi.getFeaturesAdmin().pipe(
      tap((data) => {
        context.patchState({ features: data });
      })
    );
  }
}
